const colors = {
  '--black-oak': '#4F4F4F',
  '--bluish': '#2378BB',
  '--brainstem-grey': '#000000',
  '--cerulean': '#51AFE9',
  '--cerulean': '#55ACEE',
  '--chat-orange': '#F79A3A',
  '--covered-in-platinum': '#000000',
  '--dark-grey': '#FFFFFF',
  '--davys-grey': '#545454',
  '--dazzling-blue': '#3750A2',
  '--dhūsar-grey': '#ABABAB',
  '--dim-grey': '#696B6A',
  '--dover-grey': '#848484',
  '--dubarry': '#EA5F61',
  '--edge-of-black': '#53585F',
  '--fandango': '#A7328B',
  '--glazed-persimmon': '#D94E31',
  '--golden-gate-bridge': '#BF372D',
  '--grey': '#808080',
  '--high-blue': '#4FABE6',
  '--ibiza-blue': '#007AB6',
  '--integra': '#405E96',
  '--iron-fixture': '#5D5C5C',
  '--knights-armor': '#5D5D5D',
  '--kuroi-black': '#10161A',
  '--mako': '#525454',
  '--namara-grey': '#7B7B7B',
  '--nickel': '#929292',
  '--onyx-heart': '#36383A',
  '--pink-delight': '#FF8BD8',
  '--poppy-red': '#DB3737',
  '--purple-plum': '#A254B5',
  '--red': '#FF0000',
  '--rose-madder': '#E63636',
  '--sanctuary-spa': '#69ADE1',
  '--shadowed-steel': '#4A4A4A',
  '--smoked-pearl': '#636363',
  '--sonic-silver': '#767676',
  '--sumi-ink': '#595959',
  '--tall-ships': '#137CBD',
  '--tangerine': '#FF9300',
  '--thimbleberry': '#E2474F',
  '--warm-purple': '#A33190',
  '--waterline-blue': '#4267B2',
  '--wax': '#F2F2F2',
  '--white': '#000000',
  '--yellow-green': '#000000',
  '--secondary': '#BB0A30',
  '--zombie': '#595A5A',
  '--black': '#FFFFFF'
}

module.exports = colors



// WEBPACK FOOTER //
// ./src/constants/theme/audi.js